import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import paths from 'routes/paths';

const useLogout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      console.log('Logout process completed, navigating to logout page');
      navigate(paths.simpleLogout);
    } catch (error) {
      console.error('Logout hook error:', error);
      // Still navigate to logout page even if logout fails
      console.log('Navigating to logout page despite error');
      navigate(paths.simpleLogout);
    }
  };

  return { handleLogout };
};

export default useLogout;

